















import Vue from 'vue'
import MobileNav from './MobileNav.vue'
import Navigation from './Navigation.vue'

export default Vue.extend({
  components: {
    Navigation,
    MobileNav
  },
  data () {
    return {
      isMobileNavActive: false
    }
  },
  mounted () {
    const hash = this.$route.hash
    if (hash !== '') {
      const targetId = hash.substring(1)
      this.scrollToElement(targetId)
    }
  },
  methods: {
    scrollToElement (id: string) {
      const el = document.getElementById(id)

      if (el) {
        const y = el.getBoundingClientRect().top + window.pageYOffset - 57
        window.scrollTo({ top: y, behavior: 'smooth' })
      }

      this.isMobileNavActive = false
    }
  }
})
